import { Navigate } from 'react-router-dom';

import { useCurrentPartner } from 'services/repositories/partners/partners';
import { SettingsRoutes } from 'support/types';

/**
 * The SSCC configuration endpoints are only served to partners that `ssccSettingsAvailable` reports — a
 * supplier for whom Procuros activated the module, a 3PL that trades with such a supplier, or a buyer that
 * requires SSCC labels — so this gate mirrors the backend's 403 instead of letting the page render and fail.
 */
export const SsccSettingsRoute = ({ children }: { children: React.ReactNode }) => {
  const { data: currentPartner, isLoading } = useCurrentPartner();

  if (isLoading) {
    return null;
  }

  if (!currentPartner?.ssccSettingsAvailable) {
    return <Navigate to={SettingsRoutes.companyData} replace />;
  }

  return <>{children}</>;
};
